module.exports = new __parcel__URL__("si_nmnh.efe43d16.png").toString();